'use client';
import { HeightSinceWidth, PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { ComponentType } from 'react';
import { Props as MyAccountComponentProps } from './my-account.component';
import dynamic from 'next/dynamic';

const DynamicMyAccountComponent: ComponentType<MyAccountComponentProps> = dynamic(
  () => import('./my-account.component')
);

export default DynamicMyAccountComponent;

export function calculateMyAccountPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth: HeightSinceWidth = [
    { sinceWidth: 0, height: 200 },
    { sinceWidth: 768, height: 250 },
    { sinceWidth: 1024, height: 400 }
  ];

  return {
    heightSinceWidth
  };
}
